(() => {
  const readCartRecommendedProducts = () => {

    const isCartRecommendedProdcutsEnabled = window._growthbook?.getFeatureValue(
      "cart-recommended-products",
      false
    );

    const isHoldoutGroupEnable = window._growthbook.getFeatureValue(
      "holdout-pdm-the-meatery", // fijarse en el valor del feature flag del holdout group
      "OFF",
    );

    if (isCartRecommendedProdcutsEnabled && isHoldoutGroupEnable === "OFF") {
        document.body.setAttribute("data-recommended-products", "true");
    }
  };

  const readPdmStickyAtcFF = () => {
    const pdmStickyRibbonEnabled = window._growthbook?.getFeatureValue(
      "pdm-sticky-atc-feature",
      false
    );
    if (pdmStickyRibbonEnabled) {
      document.body.setAttribute("data-sticky-atc-anchor", "true");
    }
  };

  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push((gb) => {
    // Function that uses feature flags to make changes to the page
    const applyFeatureFlags = () => {
      readPdmStickyAtcFF();
      readCartRecommendedProducts();
    };

    // Call your function initially plus whenever new data is received
    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
})();
